import type { FaultEvent } from "../../../../api/useFaultEvents";

export const getDetectionTag = ({
  isClosable,
  statusByAnalysis,
}: {
  isClosable: FaultEvent["metadata"]["isClosable"];
  statusByAnalysis: FaultEvent["metadata"]["faults"][number]["statusByAnalysis"];
}): "closable" | "singleEvent" | null => {
  const isSingleFaultEvent = statusByAnalysis.length === 1;
  if (isSingleFaultEvent) return "singleEvent";
  if (isClosable) return "closable";
  return null;
};

export const getFaultEventPriority = (event: FaultEvent) =>
  event.priority ?? event.metadata.priority;
